/**
 * JavaScript types
 * */
export const JAVASCRIPT_TYPES = {
    OBJECT: 'object',
    STRING: 'string',
};
